module.exports = __webpack_public_path__ + "media/components/common/formParts/img/dummy-button-5522bf201661f072790f900ff1eb6474.png";